// Neu (SPEC 03 §8.2) — true, sobald `bedingung` ununterbrochen `ms` lang galt; fällt sie ab,
// ist der Wert sofort wieder false. Einsatz: der Halo erscheint auf einer Kachel oder einem
// Bereich erst, wenn das Laden länger als LOADER_MS (2 s) dauert.
import { useEffect, useState } from "react";

export function useVerzoegert(bedingung: boolean, ms: number): boolean {
  const [an, setAn] = useState(false);
  useEffect(() => {
    if (!bedingung) {
      setAn(false);
      return;
    }
    const uhr = setTimeout(() => setAn(true), ms);
    return () => clearTimeout(uhr);
  }, [bedingung, ms]);
  return bedingung && an;
}
